<!--
 * @Date: 2020-08-26 16:46:17
 * @Author: MX
 * @LastEditTime: 2025-02-11 13:52:14
 * @Description: 忘记密码
-->
<template>
  <div class="forgetPassword main-wrap" id="forgetPassword">
    <video class="video-box" style="" @contextmenu.prevent id="bannerVideo" src="./login.mp4" disablePictureInPicture="true" controlslist="nodownload nofullscreen noremoteplayback" autoplay loop muted></video>
    <div class="forgetPassword-title">
<!--      {{ $lang('登录/重置密码') }}-->
    </div>
    <div class="forgetPassword-box">
      <div class="title">
        {{ $lang('重置密码') }}
      </div>
      <div class="form">
        <el-form
          ref="forgetPasswordForm"
          :model="forgetPasswordForm"
          :rules="rules"
          id="forgetPassword-form"
          autocomplete="off"
          class="login-form"
        >
        <template v-if="!isReset">
          <el-form-item class="phoneFormItem" prop="phone">
            <el-input
              class="phone-email"
              :placeholder="$lang(`请输入${forgetPasswordForm.verifyType === 'phone' ? '手机号' : '邮箱'}`)"
              :maxlength="forgetPasswordForm.verifyType === 'phone' ? 11 : 100"
              v-model="forgetPasswordForm.phone"
            >
              <el-select slot="prefix" v-model="forgetPasswordForm.verifyType" style="width: 80px;" @change="typeChange">
                <el-option :label="$lang('手机号')" value="phone"></el-option>
                <el-option :label="$lang('邮箱')" value="email"></el-option>
              </el-select>
              <!-- <i slot="prefix" class="iconfont icondengluzhuce_shouji" :class="forgetPasswordForm.phone && 'red_color'"></i> -->
            </el-input>
            <button
              class="sendcodeBtn commonBtn"
              @click.prevent="checkPhone"
              :disabled="isSendCode || sendLoading"
              v-loading="sendLoading"
            >
              <span v-if="!isSendCode">{{ $lang('发送') }}</span>
              <span v-else>{{ time + $lang('秒') }}</span>
            </button>
          </el-form-item>
          <el-form-item prop="captcha">
            <el-input
              :placeholder="$lang('请输入验证码')"
              maxlength="10"
              autocomplete="off"
              v-model="forgetPasswordForm.captcha"
            >
              <i slot="prefix" class="iconfont icondengluzhuce_yanzhengma"  :class="forgetPasswordForm.captcha && 'red_color'"></i>
            </el-input>
          </el-form-item>
          <!-- 防止浏览器的自动记录密码 账号自动输入到验证码处 -->
          <input type="text" style="position: absolute;left: -10000px;">
        </template>
        <template v-else>
          <el-form-item prop="oldPassword">
            <el-input
              :placeholder="$lang('请输入旧密码')"
              maxlength="18"
              :type="isShowOldPwd ? 'text' : 'password'"
              v-model="forgetPasswordForm.oldPassword"
            >
              <i slot="prefix" class="iconfont icondengluzhuce_mima"  :class="forgetPasswordForm.oldPassword && 'red_color'"></i>
              <i
                slot="suffix"
                class="iconfont pointer"
                :class="[
                  isShowOldPwd
                    ? 'icondenglu_ico_mimakeshi'
                    : 'icondenglu_ico_mimayincang',
                ]"
                @click="toggleIcon('isShowOldPwd')"
              ></i>
            </el-input>
          </el-form-item>
        </template>
          <el-form-item prop="password">
            <el-input
              :placeholder="$lang('请输入新密码')"
              maxlength="18"
              name="password"
              autocomplete="new-password"
              :type="isShowPassword ? 'text' : 'password'"
              v-model="forgetPasswordForm.password"
            >
              <i slot="prefix" class="iconfont icondengluzhuce_mima"  :class="forgetPasswordForm.password && 'red_color'"></i>
              <i
                slot="suffix"
                class="iconfont pointer"
                :class="[
                  isShowPassword
                    ? 'icondenglu_ico_mimakeshi'
                    : 'icondenglu_ico_mimayincang',
                ]"
                @click="toggleIcon('isShowPassword')"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="passwordAgain">
            <el-input
              :placeholder="$lang('请再次输入新密码')"
              maxlength="18"
              type="password"
              autocomplete="new-password"
              v-model="forgetPasswordForm.passwordAgain"
            >
              <i slot="prefix" class="iconfont icondengluzhuce_mima"></i>
            </el-input>
          </el-form-item>
          <button class="commonBtn cancelBtn" @click.prevent="cancel">
            {{ $lang('取消') }}
          </button>
          <button class="commonBtn submitBtn" @click.prevent="submit">
            {{ $lang('提交') }}
          </button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import * as Api from '@/api'
import { RULES } from '@/constants/rules'
import { RESPONSE_SUCCESS } from '@/constants'
// import '@/assets/js/TCaptcha'
import debounce from 'lodash/debounce'
import { AESUtil } from '@/utils/'
export default {
  name: 'ForgetPassword',
  props: {
    isReset: {
      type: Boolean,
      default: false,
    }
  },
  components: {},
  data() {
    const resetInfo = JSON.parse(localStorage.getItem('resetData') || '{}')
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.forgetPasswordForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    const noInfo = (rule, value, callback) => {
      const { account, phone } = resetInfo
      const { password, phone: oldPhone } = this.forgetPasswordForm
      if (account && phone) {
        // 重置密码
        if (password.includes(account) || password.includes(phone)) {
          callback(new Error(this.$lang('不能与用户名或者手机号一致')))
        } else {
          callback()
        }
      } else if (oldPhone && password) {
        // 忘记密码
        if (password.includes(oldPhone)) {
          callback(new Error('密码中不能包含用户名或者手机号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const validateResetPass = (rule, value, callback) => {
      // 重置密码判断
      const { password, oldPassword } = this.forgetPasswordForm
      if (this.isReset && password && oldPassword && password === oldPassword) {
        callback(new Error('新密码不能与旧密码一致'))
      } else {
        callback()
      }
    }
    return {
      sendLoading: false, // 发送验证码loading
      isSendCode: false,
      time: 60,
      codeTimer: null,
      rules: {
        // phone: [RULES.phone, RULES.checkPhone],
        phone: [RULES.phone],
        captcha: [RULES.phoneCode],
        oldPassword: [RULES.password],
        password: [RULES.password, RULES.passwordNew, { validator: noInfo, trigger: 'blur' }, { validator: validateResetPass, trigger: 'blur' }],
        passwordAgain: [{ validator: validatePass, trigger: 'blur' }],
      },
      forgetPasswordForm: {
        phone: '',
        captcha: '',
        oldPassword: '',
        password: '',
        passwordAgain: '',
        verifyType: 'phone'
      },
      account: '', // 账号
      isShowPassword: false, //不显示
      isShowOldPwd: false, // 显示旧密码
      captcha:""//腾讯验证码
    }
  },
  mounted(){
    this.initTencentCaptcha()
  },
  methods: {
    typeChange() {
      this.rules.phone = this.forgetPasswordForm.verifyType === 'phone' ? [RULES.phone] : [RULES.email, RULES.emailNull]
    },
    toggleIcon(key) {
      if (key) {
        this[key] = !this[key]
      }
    },
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      this.captcha = window.CaptchaSDK && window.CaptchaSDK.init(this.tencentCaptchaCallback, { forceLang: 'zh-cn' });
      // 显示验证码
      // this.captcha.show()
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res);
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        //发送验证码
        this.sendCode(customParams)
        return res
      }
      // 验证不成功
      return null
    },
    /**
     * @description 6.校验手机号
     */
    checkPhone:debounce(function() {
      if (!this.forgetPasswordForm.phone) {
        return this.$message.warning(this.$lang(`请输入${this.forgetPasswordForm.verifyType === 'phone' ? '手机号' : '邮箱'}`))
      }
      // if (!VALIDATION.phoneNumber.value.test(this.forgetPasswordForm.phone)) {
      //   return this.$message.warning('请输入正确的手机号')
      // }
      this.captcha?this.captcha.show():this.$message.warning(this.$lang('网络出错，请刷新后尝试！'));
    },500),
    //发送验证码
    async sendCode(customParams) {
      this.sendLoading = true
      const { phone, verifyType } = this.forgetPasswordForm
      let httpParams = {
        phone,
        type: 'reset_pwd',
        verifyType,
        ...customParams
      }
      if (verifyType !== 'phone') {
        delete httpParams.phone
        if (verifyType === 'email') {
          httpParams.email = phone
        }
      }
      await Api.sendMessage(httpParams).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          if (res.data) {
            this.account = res.data
          } else {
            this.account = ''
          }
          this.isSendCode = true
          clearInterval(this.codeTimer)
          this.time = 60
          this.codeTimer = setInterval(() => {
            this.time--
            if (this.time === 0) {
              this.isSendCode = false
              this.time = 60
            }
          }, 1000)
          this.$message.success(this.$lang('获取验证码成功'))
        } else {
          this.$message.error(this.$lang(res.msg))
        }
      })
      this.sendLoading = false
    },
    //取消
    cancel() {
      this.$router.push({ path: '/login' })
    },
    /**
     * @description 提交
     */
    submit() {
      this.$refs.forgetPasswordForm.validate((valid) => {
        if (valid) {
          if (this.isReset) {
            this.$emit('submit', this.forgetPasswordForm)
            return
          }
          const { phone, captcha, password, passwordAgain, verifyType} = this.forgetPasswordForm;
          const params = {
            captcha,
            password: AESUtil.aesEncrypt(password),
            passwordAgain: AESUtil.aesEncrypt(passwordAgain),
            verifyType
          }
          if (verifyType === 'phone') {
            params.phone = phone
          } else if (verifyType === 'email') {
            params.email = phone
          }
          Api.resetPwd(params).then((res) => {
            if (res.code === RESPONSE_SUCCESS) {
              this.$message.success(this.$lang('修改密码成功'))
              this.$router.push({ path: '/login' })
            } else {
              this.$message.error(this.$lang(res.msg))
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
  destroyed() {
    clearInterval(this.codeTimer)
  },
}
</script>

<style lang="scss" scoped>
.forgetPassword {
  position: relative;
  height: 100vh;
  overflow: hidden;
  .video-box {
    position: absolute;
    width: auto;
    height: 100vh;
    top: 64px;
    left: 0;
  }
  .forgetPassword-title {
    position: absolute;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
    color: #4c4d57;
    top: 94px;
    left: 30px;
  }
  .forgetPassword-box {
    width: 520px;
    height: 530px;
    background: rgba(255, 255, 255, 0.5); /* 设置背景颜色为白色，透明度为 0.5 */
    backdrop-filter: blur(10px); /* 模糊半径设为 10 像素 */
    border-radius: 10px;
    box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.05);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .title {
      height: 86px;
      line-height: 86px;
      border-bottom: 1px solid $table-border-color;
      text-align: center;
      font-size: 24px;
      color: #2b2d42;
      font-weight: 600;
    }
    .form {
      padding: 0 100px;
      box-sizing: border-box;
      padding-top: 50px;
      .iconfont {
        font-size: 20px;
        &.red_color {
          color: $theme-color;
        }
      }
    }
    .cancelBtn,
    .submitBtn {
      width: 144px;
      height: 54px;
      background-color: #fff;
      color: #4c4d57;
      margin-top: 8px;
    }
    .submitBtn {
      background-color: $theme-color;
      color: #fff;
      font-size: 18px;
      background-image: linear-gradient(to right, #D31027 0%, #EA384D  51%, #D31027  100%);
      padding: 15px 45px;
      text-align: center;
      text-transform: uppercase;
      transition: 0.5s;
      background-size: 200% auto;
      color: white;
      box-shadow: 0 0 20px #eee;
      border-radius: 2px;
    }
    .submitBtn:hover {
      background-position: right center !important; /* change the direction of the change here */
      color: #fff !important;
      text-decoration: none !important;
    }

    .cancelBtn {
      margin-right: 32px;
      font-size: 18px;
      background-image: linear-gradient(to right, #ffeeee 0%, #FFFFFF 51%, #efabab 100%);
      padding: 15px 45px;
      text-align: center;
      text-transform: uppercase;
      transition: 0.5s;
      background-size: 200% auto;
      color: #c31422;
      box-shadow: 0 0 20px #eee;
      border-radius: 2px;
    }

    .cancelBtn:hover {
      background-position: right center; /* change the direction of the change here */
      color: #c31422;
      text-decoration: none;
    }
    .phoneFormItem {
      position: relative;
      .sendcodeBtn {
        position: absolute;
        width: 72px;
        height: 32px;
        border-radius: 4px;
        font-size: 14px;
        right: 10px;
        top: 9px;
        border: 1px solid #c4c8cc;
      }
    }
  }
}
.forgetPassword::v-deep {
  .el-form-item__content {
    height: 50px;
    line-height: 50px;
    .el-input__inner {
      height: 50px;
      line-height: 50px;
    }
  }
  .el-input:focus-within .iconfont {
    color: $theme-color;
  }
  .el-input__prefix {
    left: 10px;
  }
  .el-input__suffix {
    right: 10px;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 40px;
  }
  .phone-email .el-input__inner {
    padding-left: 100px;
    padding-right: 85px;
  }
  .el-input--prefix .el-select .el-input__inner {
    padding-left: 0;
    padding-right: 0;
    border: none;
    height: 48px;
    line-height: 48px;
    border-right: 1px solid #DCDFE6;
    border-radius: 0;
    padding-right: 0;
    &:focus {
      border-color: #DCDFE6 !important;
    }
  }
}
</style>
<style lang="scss">
#forgetPassword {
  .el-loading-spinner{
    margin-top: -10px;
    .circular {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
